<script setup lang="ts">
import Select from 'primevue/select';
import ToggleButton from 'primevue/togglebutton';

const runtimeConfig = useRuntimeConfig();
const locales = ref<string[]>();
const { toggleLocaleDebug, changeLocale, getLocale, debugEnabled } =
  useLocaleUtils();
const { $fetch } = useNuxtApp();

onMounted(async () => {
  locales.value = await $fetch<string[]>(
    `${runtimeConfig.public.config}/cron/folders/locales/jackpotcity`,
    {},
  );
});

const availableLocales = computed(() =>
  locales.value?.map((l) => {
    return {
      code: l.split('.')[0],
      name: l.split('.')[0],
    };
  }),
);
</script>

<template>
  <div class="flex gap-2">
    <ToggleButton
      on-label="Debug on"
      off-label="Debug off"
      class="p-2 rounded-lg stacked-border text-sm truncate items-center"
      :class="[
        {
          'bg-primary text-base text-base-color': !debugEnabled(),
          'bg-success-500 text-light-50 font-bold': debugEnabled(),
        },
      ]"
      :model-value="debugEnabled()"
      @change="toggleLocaleDebug()"
    />
    <Select
      :disabled="!availableLocales?.length"
      :model-value="getLocale()"
      append-to="self"
      option-label="name"
      option-value="code"
      :options="availableLocales"
      placeholder="Select Locale"
      class="w-full md:w-56 bg-primary"
      size="small"
      @change="(e) => changeLocale(e.value)"
    />
  </div>
</template>

<style scoped></style>
